import { Button } from "@mantine/core";
import { type ReactNode, useCallback } from "react";

import {
  BottomText,
  ButtonContainer,
  CardContainer,
  CardName,
  CardSeparator,
  NoEntries,
} from "./Card.styled";
import { useSelector } from "src/redux/hooks";

interface ICardProps {
  children?: ReactNode;
  cardName: string;
  cardDetails?: string;
  bottomText?: string;
  data?: string;
  button?: string;
  isLoading?: boolean;
  onClick?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
}

const Card = ({
  cardName,
  cardDetails,
  onClick,
  button,
  bottomText,
  children,
  disabled,
  onDelete,
}: ICardProps) => {
  const handleClick = useCallback(() => {
    if (!disabled && onClick) {
      onClick();
    }
  }, [disabled, onClick]);

  const handleDelete = useCallback(
    (e: any) => {
      e.stopPropagation();
      if (onDelete) onDelete();
    },
    [onDelete],
  );

  const uppercase = useSelector(state => state.preferencesSlice.uppercase);

  return (
    <CardContainer data-cy="card" onClick={handleClick} disabled={disabled}>
      <CardName>{uppercase ? cardName.toUpperCase() : cardName}</CardName>
      <CardSeparator disabled={disabled} />
      <NoEntries>{cardDetails}</NoEntries>
      <ButtonContainer style={{ gap: 10 }}>
        {onDelete && (
          <Button
            data-testid="Button"
            color="red"
            variant="outline"
            onClick={handleDelete}>
            Delete
          </Button>
        )}
        {button && (
          <Button
            data-testid="Button"
            color={button === "pdf" ? "red" : "teal"}
            variant="outline">
            {button.toUpperCase()}
          </Button>
        )}
      </ButtonContainer>
      {bottomText && (
        <BottomText data-testid="BottomText">{bottomText}</BottomText>
      )}
      {children}
    </CardContainer>
  );
};

export default Card;
